import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  customerOnWaterReport,
  CustomerOnWaterReport,
} from "../../actions/shipmentNPayment";
import Table from "../../common/Table";
import { NavWrap, TableWrap } from "../ShopForTyres";

import { DownloadOutlined } from "@ant-design/icons";
import { saveAs } from "file-saver";
import json2csv from "json2csv";

const StatusLegend = () => {
  const legend = [
    { color: "#fadb14", label: "Open – Pending Shipment" },
    { color: "#1890ff", label: "Planned Delivery – Scheduled" },
    { color: "#52c41a", label: "Shipped – In transit" },
    { color: "#ff4d4f", label: "Cancelled – Cancelled" },
  ];

  return (
    <div style={{ display: "flex", gap: 10, marginBottom: 12, marginLeft: 20 }}>
      {legend.map((item) => (
        <div
          key={item.label}
          style={{ display: "flex", alignItems: "center", gap: 6 }}
        >
          <span
            style={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              backgroundColor: item.color,
              display: "inline-block",
            }}
          />
          <span style={{ fontSize: "0.8rem"}} >
                {item.label}
          </span>
        </div>
      ))}
    </div>
  );
};

const OnWaterReport = () => {
  const dispatch = useDispatch();
  const shipment_list = useSelector(
    (state) => state?.shipNPay?.on_water_report
  );

  const history = useHistory();
  const [dates, setDates] = useState({});
  const [filters, setFilters] = useState({
    status: "Planned Delivery",
  });
  const location = useLocation();
  const [tableScroll, setTableScroll] = useState({ x: "100%" });

  useEffect(() => {
    const screenWidth = window.screen.width;
    const newScroll = screenWidth > 3000 ? { x: "100%" } : { x: 3600 };
    setTableScroll(newScroll);
  }, []);
  useEffect(() => {
    let fils = location?.state?.filters ? location?.state?.filters : filters;
    if (location?.state?.filters) {
      setFilters(fils);
      history.replace("/on-water-report");
    }

    dispatch(
      customerOnWaterReport({
        email: localStorage.getItem("email"),
        status: "Planned Delivery",
      })
    );
    // eslint-disable-next-line
  }, [dates]);

  const columns = [
    {
      header: "IP Code",
      accessor: "Matnr",
      width: 10,
    },
    {
      header: "Your Item Code",
      accessor: "Kdmat",
      width: 15,
    },
    {
      header: "Item Description",
      accessor: "Arktx",
      width: 17,
    },
    {
      header: "Brand",
      accessor: "Zzbrand",
      width: 8,
    },
    {
      header: "Pattern",
      accessor: "Zzpattern",
      width: 8,
    },
    {
      header: "Sales Order Number",
      accessor: "Vbeln",
      width: 10,
    },
    {
      header: "Your PO Number",
      accessor: "Bstkd",
      width: 15,
    },
    {
      header: "Order Date",
      accessor: "Audat",
      width: 10,
      cell: (row) =>
        row.Audat ? (
          <span>
            {moment(parseInt(row.Audat.match(/\d+/)[0], 10)).format(
              "DD/MM/YYYY"
            )}
          </span>
        ) : (
          ""
        ),
    },
    {
      header: "Delivery Number",
      accessor: "Delno",
      width: 10,
    },
    {
      header: "Shipment ID",
      accessor: "Tknum",
      width: 12,
    },
    {
      header: "Customer",
      accessor: "Name1",
      width: 10,
    },
    {
      header: "Destination",
      accessor: "City1",
      width: 10,
    },
    {
      header: "Material Availability Date",
      accessor: "Edatu",
      width: 10,
      cell: (row) =>
        row.Edatu ? (
          <span>
            {moment(parseInt(row.Edatu.match(/\d+/)[0], 10)).format(
              "DD/MM/YYYY"
            )}
          </span>
        ) : (
          ""
        ),
    },
    {
      header: "ETD",
      accessor: "Dalen",
      width: 10,
      cell: (row) =>
        row.Dalen ? (
          <span>
            {moment(parseInt(row.Dalen.match(/\d+/)[0], 10)).format(
              "DD/MM/YYYY"
            )}
          </span>
        ) : (
          ""
        ),
    },
    {
      header: "ETA",
      accessor: "Datbg",
      width: 10,
      cell: (row) =>
        row.Datbg ? (
          <span>
            {moment(parseInt(row.Datbg.match(/\d+/)[0], 10)).format(
              "DD/MM/YYYY"
            )}
          </span>
        ) : (
          ""
        ),
    },
    {
      header: "Container Number",
      accessor: "Signi",
      width: 10,
    },
    {
      header: "Quantity (Pcs)",
      accessor: "Menge",
      width: 10,
      cell: (row) => <span>{parseInt(row.Menge)}</span>,
    },
    // {
    //   header: "Cust. Code",
    //   accessor: "Kunnr",
    //   width: 10,
    // },
    // {
    //   header: "Stuffing Date",
    //   accessor: "Dalbg",
    //   width: 10,
    //   cell: (row) =>
    //     row.Dalbg ? (
    //       <span>
    //         {moment(parseInt(row.Dalbg.match(/\d+/)[0], 10)).format(
    //           "DD/MM/YYYY"
    //         )}
    //       </span>
    //     ) : (
    //       ""
    //     ),
    // },
    {
      header: "Fill",
      accessor: "Zfill",
      cell: (row) => <span>{parseFloat(row.Zfill).toFixed(3)}</span>,
      width: 10,
    },
    {
      header: "Delivery Status",
      accessor: "Status",
      width: 10,
    },
    {
      header: "Port of Loading",
      accessor: "Zzporttext",
      width: 10,
    },
    {
      header: "Cancellation Reason",
      accessor: "AbgruTxt",
      width: 10,
    },
  ];

  return (
    <div className="shop-tyres">
      <NavWrap>
        <TableWrap
          isFilter={false}
          showBulk={false}
          name={"On Water Shipment Report"}
          showGrid={false}
          isDateFilter={false}
          searchPlaceholder={"Search by SO..."}
          namedFilters={[
            {
              label: "Open",
              action: () => {
                let obj = {
                  email: localStorage.getItem("email"),
                  status: "Open",
                };
                if (filters.search_key) {
                  obj.search_key = filters.search_key;
                }
                setFilters((f) => ({
                  ...f,
                  status: "Open",
                }));
                dispatch(customerOnWaterReport(obj));
                dispatch({ type: CustomerOnWaterReport.RESET });
              },
              isActive: filters.status === "Open",
            },
            {
              label: "Planned Delivery",
              action: () => {
                let obj = {
                  email: localStorage.getItem("email"),
                  status: "Planned Delivery",
                };
                if (filters.search_key) {
                  obj.search_key = filters.search_key;
                }
                setFilters((f) => ({
                  ...f,
                  status: "Planned Delivery",
                }));
                dispatch(customerOnWaterReport(obj));
                dispatch({ type: CustomerOnWaterReport.RESET });
              },
              isActive: filters.status === "Planned Delivery",
            },
            {
              label: "Shipped",
              action: () => {
                let obj = {
                  email: localStorage.getItem("email"),
                  status: "Shipped",
                };
                if (filters.search_key) {
                  obj.search_key = filters.search_key;
                }
                setFilters((f) => ({
                  ...f,
                  status: "Shipped",
                }));
                dispatch({ type: CustomerOnWaterReport.RESET });
                dispatch(customerOnWaterReport(obj));
              },
              isActive: filters.status === "Shipped",
            },
            {
              label: "Cancelled",
              action: () => {
                let obj = {
                  email: localStorage.getItem("email"),
                  status: "Cancelled",
                };
                dispatch({ type: CustomerOnWaterReport.RESET });
                if (filters.search_key) {
                  obj.search_key = filters.search_key;
                }
                setFilters((f) => ({
                  ...f,
                  status: "Cancelled",
                }));
                dispatch(customerOnWaterReport(obj));
              },
              isActive: filters.status === "Cancelled",
            },
            {
              label: "All ",
              action: () => {
                let obj = {
                  email: localStorage.getItem("email"),
                };
                if (filters.search_key) {
                  obj.search_key = filters.search_key;
                }
                setFilters((f) => ({
                  ...f,
                  status: "",
                }));
                dispatch({ type: CustomerOnWaterReport.RESET });
                dispatch(customerOnWaterReport(obj));
              },
              isActive: filters.status === "",
            },
            // { label: "PSA Cancelled", action: () => { } },
          ]}
          exportComponent={
            <button
              disabled={shipment_list?.loading || !shipment_list?.data?.length}
              onClick={() => {
                let prods = shipment_list?.data?.map((ele) => {
                  let obj = {};
                  columns?.forEach((itm) => {
                    if (
                      ["Dalbg", "Dalen", "Datbg", "Audat", "Edatu"]?.includes(
                        itm.accessor
                      )
                    ) {
                      obj[itm.header] = ele[itm.accessor]
                        ? moment(
                            parseInt(ele[itm.accessor].match(/\d+/)[0], 10)
                          ).format("DD/MM/YYYY")
                        : "";
                    } else obj[itm.header] = ele[itm.accessor];
                  });
                  return obj;
                });
                let csv = json2csv.parse(prods);
                var blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
                saveAs(blob, "OnWaterReport.csv");
              }}
            >
              <DownloadOutlined color="#333" />
            </button>
          }
          rangePlaceholder={["ETD Start date", "ETD End date"]}
          options={[{ label: "All Dates", value: "all" }]}
          label={""}
          total_count={shipment_list?.data?.length}
          perPageLimit={shipment_list?.data?.length}
          isRange={true}
          callSearch={(search) => {
            let obj = {
              email: localStorage.getItem("email"),
            };
            if (dates.end_date && dates.start_date) {
              obj = { ...obj, ...dates };
            }
            if (filters.status) {
              obj.status = filters.status;
            }
            dispatch({ type: CustomerOnWaterReport.RESET });
            dispatch(customerOnWaterReport({ ...obj, search_key: search }));
            setFilters((f) => ({ ...f, search_key: search }));
          }}
          searchVal={filters.search_key || ""}
          onRangeChange={(val) => {
            let start_date = val?.[0] ? moment(val?.[0]) : null;
            let end_date = val?.[1] ? moment(val?.[1]) : null;
            if (val === null) {
              setDates({});
            } else {
              if (start_date && end_date) {
                setDates({
                  start_date,
                  end_date,
                });
              }
            }
          }}
        >
          <StatusLegend />
          <Table
            columns={columns}
            data={Array.isArray(shipment_list?.data) ? shipment_list?.data : []}
            loading={shipment_list?.loading}
            scroll={tableScroll}
          />
        </TableWrap>
      </NavWrap>
    </div>
  );
};

export default OnWaterReport;
